<template>
  <v-card class="card-border">
    <v-card-text>
      <v-data-table
        ref="dataTable"
        :headers="headers"
        :items="getDataTable"
        :search="search"
        sort-by="descricao"
      >
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="search" label="Procurar..." prepend-inner-icon="mdi-magnify" />
            </v-col>
          </v-row>
        </template>

        <template
          v-slot:item.coeficienteCotaRepo="{ item }"
        >{{ item.coeficienteCotaRepo | percent }}</template>

        <template v-slot:item.ativo="{ item }">
          <v-btn color="transparent" small fab depressed>
            <v-icon
              :color="item.ativo ? 'green' : 'red'"
              @click="$ability.can('Editar', 'Consorcio') ? updateAtivo(item) : ''"
            >{{ item.ativo ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.emplacamento="{ item }">
          <v-btn color="transparent" small fab depressed>
            <v-icon
              :color="item.emplacamento ? 'green' : 'red'"
              @click="$ability.can('Editar', 'Consorcio') ? updateEmplacamento(item) : ''"
            >{{ item.emplacamento ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-tooltip v-if="$ability.can('Ver Prazos', 'Consorcio')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogTablePrazos.show(item)"
              >
                <v-icon>mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            Prazos
          </v-tooltip>
          <v-tooltip v-if="$ability.can('Vincular Veiculos', 'Consorcio')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.vincularVeiculos.show(item)"
              >
                <v-icon>mdi-car</v-icon>
              </v-btn>
            </template>
            Vincular/Desvincular Veiculos
          </v-tooltip>
          <v-tooltip v-if="$ability.can('Vincular Empresas', 'Consorcio')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="transparent"
                small
                fab
                depressed
                @click="$refs.vincularEmpresas.show(item)"
              >
                <v-icon>mdi-domain</v-icon>
              </v-btn>
            </template>
            Vincular/Desvincular Empresas
          </v-tooltip>
          <v-tooltip v-if="$ability.can('Editar', 'Consorcio')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogConsorcio.show(true, item)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            Editar Consocio
          </v-tooltip>
        </template>
      </v-data-table>
      <DialogTablePrazos ref="dialogTablePrazos" />
      <VincularVeiculos ref="vincularVeiculos" @updated="updateVeiculos($event)" />
      <VincularEmpresas ref="vincularEmpresas" @updated="updateEmpresas($event)" />
      <DialogConsorcio ref="dialogConsorcio" @updated="update($event)" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Consorcio from "@/services/consorcio";

export default {
  name: "Table",

  components: {
    DialogTablePrazos: () => import("./DialogTablePrazos"),
    VincularVeiculos: () => import("./VincularVeiculos"),
    VincularEmpresas: () => import("./VincularEmpresas"),
    DialogConsorcio: () => import("./DialogConsorcio")
  },

  data() {
    return {
      headers: [
        { text: "Descrição", value: "descricao", align: "start" },
        {
          text: "Coeficiente Cota Reposição",
          value: "coeficienteCotaRepo",
          align: "start"
        },
        {
          text: "Emplacamento",
          value: "emplacamento",
          sortable: false,
          align: "center"
        },
        { text: "Ativo", value: "ativo", sortable: false, align: "center" },
        { text: "Ações", value: "acoes", sortable: false, align: "center" }
      ],
      search: "",
      serviceConsorcio: new Consorcio()
    };
  },

  methods: {
    updateVeiculos(consorcio) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === consorcio.id
      );
      if (consorcio.veiculos.length === 0) {
        this.$refs.dataTable.items[index].veiculos = [];
      } else {
        this.$refs.dataTable.items[index].veiculos = consorcio.veiculos.map(
          veiculo => veiculo
        );
      }
    },

    updateEmpresas(consorcio) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === consorcio.id
      );
      if (consorcio.empresas.length === 0) {
        this.$refs.dataTable.items[index].empresas = [];
      } else {
        this.$refs.dataTable.items[index].empresas = consorcio.empresas.map(
          empresa => empresa
        );
      }
    },

    updateAtivo(consorcio) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === consorcio.id
      );
      let estadoInicial = consorcio.ativo;
      let texto = "";
      if (consorcio.ativo) {
        texto = `Deseja Desativar Consorcio ${consorcio.descricao}?`;
      } else {
        texto = `Deseja Ativar Consorcio ${consorcio.descricao}?`;
      }
      this.$swal.confirm(texto).then(async () => {
        try {
          consorcio.ativo = !consorcio.ativo;
          await this.serviceConsorcio.update({ ...consorcio });
          await this.serviceConsorcio.criaHistoricoAtualizacaoAtivo(
            { ...consorcio },
            this.getUser.nome
          );
          this.$refs.dataTable.items.splice(index, 1);
          return Promise.resolve();
        } catch (error) {
          consorcio.ativo = estadoInicial;
          await this.serviceConsorcio.update({ ...consorcio });
          this.$toast.error(`Erro ao atualizar ativo`);
          return Promise.reject(error);
        }
      });
    },

    updateEmplacamento(consorcio) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === consorcio.id
      );
      let estadoInicial = consorcio.emplacamento;
      let texto = "";
      if (consorcio.emplacamento) {
        texto = `Deseja Desativar Emplacamento do Consorcio ${consorcio.descricao}?`;
      } else {
        texto = `Deseja Ativar Emplacamento do Consorcio ${consorcio.descricao}?`;
      }
      this.$swal.confirm(texto).then(async () => {
        try {
          consorcio.emplacamento = !consorcio.emplacamento;
          await this.serviceConsorcio.update({ ...consorcio });
          return Promise.resolve();
        } catch (error) {
          consorcio.emplacamento = estadoInicial;
          await this.serviceConsorcio.update({ ...consorcio });
          this.$toast.error(`Erro ao atualizar emplacamento`);
          return Promise.reject(error);
        }
      });
    },

    update(consorcio) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === consorcio.id
      );
      this.$refs.dataTable.items[index].ativo = consorcio.ativo;
      this.$refs.dataTable.items[index].descricao = consorcio.descricao;
      this.$refs.dataTable.items[index].emplacamento = consorcio.emplacamento;
      this.$refs.dataTable.items[index].coeficienteCotaRepo =
        consorcio.coeficienteCotaRepo;
    }
  },

  computed: {
    ...mapGetters("auth", ["getUser"]),
    ...mapGetters("consorcio", ["getConsorcios"]),

    getDataTable() {
      return this.getConsorcios || [];
    }
  }
};
</script>
